import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_tela_padrao_crud = _resolveComponent("tela-padrao-crud")!
  const _component_importacao_registros_excel_modal = _resolveComponent("importacao-registros-excel-modal")!
  const _component_kits_produtos_modal = _resolveComponent("kits-produtos-modal")!
  const _component_produto_modal = _resolveComponent("produto-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_tela_padrao_crud, {
      ref: "refCrudProduto",
      estrutura: _ctx.crudBase.estrutura,
      servicoAPI: _ctx.servicoProduto,
      "exibir-importacao": _ctx.state.exibirImportacaoExcel,
      "onUpdate:exibirImportacao": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirImportacaoExcel) = $event)),
      onExibirModal: _ctx.exibirModal,
      onSincronizaTelaCrud: _ctx.sincronizaTelaCrud
    }, {
      BotoesAdicionais: _withCtx(() => [
        _createElementVNode("button", {
          class: "ant-btn ant-btn-secondary ss-btn-recursos",
          title: "Kits de Produtos",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirKits && _ctx.abrirKits(...args)))
        }, [
          _createVNode(_component_icone, { nome: "presente" })
        ])
      ]),
      _: 1
    }, 8, ["estrutura", "servicoAPI", "exibir-importacao", "onExibirModal", "onSincronizaTelaCrud"]),
    _createVNode(_component_importacao_registros_excel_modal, {
      visivel: _ctx.state.exibirImportacaoExcel,
      "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.exibirImportacaoExcel) = $event)),
      empresa: _ctx.storeSistema.getters.codigoEmpresaOperacao()
    }, null, 8, ["visivel", "empresa"]),
    _createVNode(_component_kits_produtos_modal, {
      visivel: _ctx.state.exibirKits,
      "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.exibirKits) = $event)),
      empresa: _ctx.storeSistema.getters.codigoEmpresaOperacao()
    }, null, 8, ["visivel", "empresa"]),
    _createVNode(_component_produto_modal, {
      visivel: _ctx.crudBase.exibirModal,
      "onUpdate:visivel": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.crudBase.exibirModal) = $event)),
      operacao: _ctx.crudBase.operacao,
      "onUpdate:operacao": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.crudBase.operacao) = $event)),
      onSincronizarRegistro: _ctx.sincronizarRegistro
    }, null, 8, ["visivel", "operacao", "onSincronizarRegistro"])
  ], 64))
}